import RulesScreen from '../../Shared/RulesScreen';
import React from 'react';

const VariationRulesScreen: React.FC = () => (
  <RulesScreen rulesTableName={'Variation Rules'} variationOnly={true} />
);

export default VariationRulesScreen;
